<template>
<div>
  <el-dialog :visible="API.rowOperations[name].visible" :before-close="close" title="公式编辑器" v-if="API.rowOperations[name].visible" >
    <span class="formula-msg">用于<span class="msg-red">设备看板构建</span>的虚拟表，请勿在公式中引用其他虚拟表</span>

    <div class="item-container" >
      <!-- <div v-if="editFormula" class="edit-info">
        <p class="edit-header">公式编辑:</p>
        <div>
          <div class="edit-item">
            <span>删除 <span class="green">标签</span></span>
            <el-input-number size="mini" v-model="delIndex" :min="1" placeholder="请输入标签号" class="input-number"></el-input-number>
            <el-button size="mini" @click="handleDeleteItem" icon="el-icon-delete"></el-button>
          </div>
          <div class="edit-item">
            <span>在<span class="green">标签</span></span>
            <el-input-number size="mini" v-model="addIndex" :min="1" placeholder="请输入标签号" class="input-number">
            </el-input-number><span>前添加</span>
          </div>
          <p>标签添加或者删除完成，请选点击下方 <span class="blue">更改完成</span> 按钮保存后再进行正常编辑</p>
        </div>
      </div> -->
      <div class="item-block">
        <el-select v-model="selectedDevice" size="mini" placeholder="设备" filterable @change="handleDeviceSelected()" >
          <el-option v-for="(item, index) in deviceTextMap" :key="index" :label="item" :value="index">
          </el-option>
        </el-select>
        <el-select v-model="selectedDeviceProp" size="mini" placeholder="属性" filterable v-if="!devicePropsIsEmpty && selectedDevice">
          <el-option v-for="(item, index) in devicePropsTextMap" :key="index" :label="item" :value="index" >
          </el-option>
        </el-select>
        <el-button size="mini" icon="el-icon-plus" @click="handleAddDeviceAndProp()" :disabled="!allowAddDeviceAndProp" ></el-button>
      </div>
      <div class="item-block">
        <el-button v-for="(item, index) in avaliableOperator" :key="index" size="mini" @click="handleAddOperator(item)">{{item}}</el-button>
      </div>
      <div class="item-block">
        <el-select v-model="selectedVirtualTable" clearable size="mini" placeholder="虚拟表" filterable >
          <el-option v-for="(item, index) in virtualTable" :key="index" :label="item" :value="index" >
          </el-option>
        </el-select>
        <el-button size="mini" icon="el-icon-plus" @click="handleAddVirtualTable()" :disabled="!allowAddVirtualTable"></el-button>
      </div>
      <div class="item-block">
        <!-- <el-input v-model.number="formulaNumber" type="number" size="mini" placeholder="输入数字" ></el-input> -->
        <el-input-number v-model="formulaNumber" size="mini" :min="0" placeholder="输入数字"></el-input-number>
        <el-button size="mini" icon="el-icon-check" @click="handleAddNumber" :disabled="!allowAddNumber"></el-button>
      </div>
      <div  class="item-block">
        <el-button type="warning" size="mini" @click="handleDeleteItem()" icon="el-icon-back"></el-button>
        <el-button type="danger" size="mini" @click="handleDeleteAll()" icon="el-icon-close"></el-button>
        <!-- <el-button type="primary" size="mini" @click="changeFormula">{{editText}}</el-button>
        <el-button size="mini" v-if="editFormula" @click="editCancel">取消编辑</el-button> -->
      </div>
    </div>

    <div class="textarea-container" :class="{formulaValidate : formulaIsValidate}">
      <div v-for="(item, index) of formula" :key="index" >
        <el-tag size="mini" v-if="item.type === 'device'">
          <!-- <span v-if="editFormula" class="green">标签{{index + 1}}: </span> -->
          {{deviceTextMap[item.device]}}.{{item.attribute}}
        </el-tag>
        <el-tag size="mini" type="warning" v-if="item.type === 'Operator'">
          {{item.value}}
        </el-tag>
        <el-tag size="mini" type="success" v-if="item.type === 'number'">
          {{item.value}}
        </el-tag>
        <el-tag size="mini" type="info" v-if="item.type === 'meter'">
          {{virtualTable[item.value]}}
        </el-tag>
      </div>
    </div>
    <div>
      <el-button class="formula-sub-btn" size="mini" :disabled="allowSubmit" @click="handleSave">确定</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { getProjectDevices } from '@/api/device-controller'
import { getAttributes } from '@/api/telemetry-controller'
import { getProjectVirtual, addVirtual } from '@/api/virtual-controller'
import { formulaVerify } from '@/utils/formulaVerify'
import { removeSlash } from '@/utils/removeIdSlash.js'

import _ from 'lodash'
const math = require('mathjs')

export default {
  name: 'formulaEdit',
  props: [
    'API',
    'name'
  ],
  data() {
    return {
      selectedDevice: '',
      selectedDeviceProp: '',
      selectedVirtualTable: '',
      formulaNumber: '',
      deviceTextMap: {},
      devicePropsTextMap: {},
      devicePropsIsEmpty: true,
      propTextMap: {},
      formula: [],
      virtualTable: {},
      // editText: '公式编辑',
      // originalFormula: [],
      // editFormula: false,
      // addIndex: undefined,
      // delIndex: undefined,
      // formulaIsValidate: false,
      avaliableOperator: ['+', '-', '*', '/', '(', ')']
    }
  },
  computed: {
    allowAddDeviceAndProp() {
      if (this.selectedDevice && this.selectedDeviceProp) {
        return true
      } else {
        return false
      }
    },
    allowAddVirtualTable() {
      if (this.selectedVirtualTable) {
        return true
      } else {
        return false
      }
    },
    allowAddNumber() {
      if (this.formulaNumber) {
        return true
      } else {
        return false
      }
    },
    deviceUUID: function() {
      const src = this.selectedDevice
      const uuid = src.substring(7, 15) + '-' + src.substring(3, 7) + '-1' + src.substring(0, 3) + '-' + src.substring(15, 19) + '-' + src.substring(19)
      return uuid
    },
    deviceTextMapIsEmpty: function() {
      return _.isEmpty(this.deviceTextMap)
    },
    formulaIsValidate: function() {
      const OriginFormula = this.formula
      let formula = ''
      for (const item of OriginFormula) {
        if (item.type !== 'device' && item.type !== 'meter') {
          formula += item.value
        } else {
          formula += '1'
        }
      }
      // const result = eval(formula)
      try {
        math.evaluate(formula)
      } catch (error) {
        return true
      }
      if (formulaVerify(this.formula)) {
        return false
      } else {
        return true
      }
      // return false
    },
    allowSubmit() {
      console.log(this.formula.length, this.formula, !this.formulaIsValidate, '-----allowSubmit')
      if (this.formula.length && !this.formulaIsValidate) {
        return false
      } else {
        return true
      }
    }
  },
  created() {
    if (this.API.rowOperations.formulaEditor.row.formula) {
      this.formula = this.formulaBuilder(this.API.rowOperations.formulaEditor.row.formula)
    }
    const pId = removeSlash(this.$store.state.app.project.id.id)
    getProjectDevices(pId).then(res => {
      for (const item of res.data.data) {
        const str = item.id.id
        const id = str.substring(15, 18) + str.substring(9, 13) + str.substring(0, 8) + str.substring(19, 23) + str.substring(24)
        // this.deviceTextMap[id] = item.name
        if (item.name !== '默认网关') {
          this.$set(this.deviceTextMap, id, item.name)
        }
      }
    })
    getProjectVirtual(this.$store.state.app.project.id.id).then(res => {
      for (const item of res.data) {
        // const str = item.id.id
        // const id = str.substring(15, 18) + str.substring(9, 13) + str.substring(0, 8) + str.substring(19, 23) + str.substring(24)
        // TODO: choose serialNumber or name
        this.$set(this.virtualTable, item.serialNumber, item.name)
      }
    })
  },
  methods: {
    // changeFormula () {
    //   if (this.formula.length > 0) {
    //     if (this.editFormula) {
    //       this.editText = '公式编辑'
    //       this.editFormula = !this.editFormula
    //       this.addIndex = undefined
    //       this.delIndex = undefined
    //     } else {
    //       this.editText = '更改完成'
    //       this.editFormula = !this.editFormula
    //       this.originalFormula = []
    //       this.formula.forEach(v => {
    //         this.originalFormula.push(v)
    //       })
    //     }
    //   }
    // },
    // editCancel () {
    //   this.formula = []
    //   this.originalFormula.forEach(v => {
    //     this.formula.push(v)
    //   })
    //   this.editText = '公式编辑'
    //   this.editFormula = !this.editFormula
    //   this.addIndex = undefined
    //   this.delIndex = undefined
    // },
    // delFormula () {
    //   if (this.addIndex) {
    //     this.formula.splice(this.addIndex - 1, 1)
    //     console.log(this.delIndex, '删除标签')
    //   }
    // },
    // startInsertion() {
    //   if (this.addIndex) {
    //     this.editAdd = true
    //     console.log('开始添加', this.editAdd, this.addIndex)
    //   }
    // },
    // endInsertion() {
    //   this.editAdd = false
    //   console.log('结束添加', this.editAdd)
    // },
    close() {
      this.API.rowOperations[this.name].visible = false
    },
    handleSave() {
      let sourceFormula = ''
      for (const item of this.formula) {
        sourceFormula += item.value
      }
      this.API.rowOperations.formulaEditor.row.formula = sourceFormula
      let data = this.API.rowOperations.formulaEditor.row
      if (data.virtualGroup) {
        // FIXME:
        data.virtualGroup = data.virtualGroup.join(',')
        data = _.omit(data, 'group')
      }
      addVirtual([data]).then(res => {
        this.$message('保存虚拟表成功')
        this.API.rowOperations[this.name].visible = false
        this.API.that.$refs.itemTable.getList()
      }).catch(err => {
        console.log(err)
      })
    },
    handleDeviceSelected() {
      this.devicePropsTextMap = {}
      this.devicePropsIsEmpty = true
      getAttributes('DEVICE', this.deviceUUID).then(res => {
        for (const item of res.data) {
          if (item.key === 'prop') {
            for (const prop of JSON.parse(item.value)) {
              this.devicePropsTextMap[prop.propertyCategory] = prop.name
            }
          }
        }
        this.devicePropsIsEmpty = false
      })
    },
    handleAddDeviceAndProp() {
      const newDevice = {}
      newDevice.type = 'device'
      newDevice.value = this.selectedDevice + '.' + this.selectedDeviceProp
      newDevice.device = this.selectedDevice
      newDevice.attribute = this.selectedDeviceProp
      if (this.editFormula) {
        this.formula.splice(this.addIndex - 1, 0, newDevice)
        console.log(this.formula, '添加----')
      } else {
        this.formula.push(newDevice)
      }
      this.selectedDevice = ''
      this.selectedDeviceProp = ''
      this.devicePropsTextMap = {}
      this.devicePropsIsEmpty = true
    },
    handleAddOperator(event) {
      const newOperator = {}
      newOperator.type = 'Operator'
      newOperator.value = event
      if (this.editFormula) {
        this.formula.splice(this.addIndex - 1, 0, newOperator)
      } else {
        this.formula.push(newOperator)
      }
    },
    handleAddNumber() {
      const newNumber = {}
      newNumber.type = 'number'
      newNumber.value = this.formulaNumber
      if (this.editFormula) {
        this.formula.splice(this.addIndex - 1, 0, newNumber)
      } else {
        this.formula.push(newNumber)
      }
      this.formulaNumber = null
    },
    handleAddVirtualTable() {
      const newVT = {}
      newVT.type = 'meter'
      newVT.value = this.selectedVirtualTable
      if (this.editFormula) {
        this.formula.splice(this.addIndex - 1, 0, newVT)
      } else {
        this.formula.push(newVT)
      }
      this.selectedVirtualTable = ''
    },
    handleDeleteItem() {
      if (this.editFormula) {
        this.formula.splice(this.delIndex - 1, 1)
      } else {
        this.formula.pop()
      }
    },
    handleDeleteAll() {
      this.formula = []
    },
    formulaBuilder(formula) {
      const splitOperator = /([\+\-\*\/\(\)])/
      // const numberRegex = /(\d+(\.\d+)?)/
      const numberRegex = /^(\d+(\.\d+)?)$/
      const meterRegex = /^[a-zA-Z](\d)+$/
      const avaliableOperator = ['+', '-', '*', '/', '(', ')']
      const layer1 = formula.split(splitOperator)
      const layer2 = layer1.filter(item => item.length > 0)
      const layer3 = layer2.map(item => {
        const rObj = {}
        if (avaliableOperator.includes(item)) {
          rObj.value = item
          rObj.type = 'Operator'
        } else if (numberRegex.test(item)) {
          rObj.value = item
          rObj.type = 'number'
        } else if (meterRegex.test(item)) {
          rObj.value = item
          rObj.type = 'meter'
        } else {
          rObj.value = item
          rObj.device = item.split('.')[0]
          rObj.attribute = item.split('.')[1]
          rObj.type = 'device'
        }
        return rObj
      })
      return layer3
    }
  }
}
</script>

<style lang="scss" scoped>
.formula-msg {
  position: relative;
  top: -15px;
  color: #74c260;
  font-size: 14px;
  .msg-red {
    color: #ec4747;
  }
}
.item-container {
  min-width: 300px;
  max-width: 400px;
  .item-block {
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    * {
      margin-right: 10px;
    }
    .el-input, .el-select {
      flex: auto
    }
  }
}
.formula-sub-btn {
  color: #fff;
  background-color: #207AE8;
  border-color: #207AE8;
}
.formula-sub-btn.is-disabled {
  color: #97a8be;
  background-color: transparent;
  border-color: #97a8be;
  &:focus, &:hover {
    color: #97a8be;
    background-color: transparent;
    border-color: #97a8be;
  }
}
.textarea-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  border: 1px solid #eee;
  border-radius: 3px;
  padding: 10px;
  margin: 15px 0;
  min-height: 120px;
  .el-tag {
    margin-right: 3px;
  }
}
.formulaValidate {
  border: 1px solid #f56c6c;
}
.green {
  color: #3fef3f;
}
.blue {
  color: #207AE8;
}
.edit-info {
  display: flex;
}
.edit-header {
  color: #fdba55;
  margin: 10px 20px 10px 0;
}
.edit-item {
  margin-bottom: 10px;
  .input-number {
    margin: 0 10px;
  }
}
</style>
